module.exports = __webpack_public_path__ + "3bd0473c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_home/Section/ic_More_Hover.png
// module id = 1140
// module chunks = 2